import Immutable from 'immutable';
import reducerCreator from '../tools/reducer-creator';
import * as types from '../actions/auth-user/types';

const initialState = Immutable.fromJS({
  userId: null,
  isLoading: false,
  sharedAuthToken: null,
  nativeAuthToken: null,
  error: null,
  signedOutExplicitly: null
});

export default reducerCreator(initialState, {
  [types.AUTH_USER_SET_LOADING]: (state, { isLoading }) =>
    state.set('isLoading', isLoading),

  [types.AUTH_USER_SET_DATA]: (
    state,
    { user, nativeAuthToken, sharedAuthToken }
  ) =>
    initialState.merge(user).merge({
      nativeAuthToken,
      sharedAuthToken
    }),

  [types.AUTH_USER_SET_ERROR]: (state, { error }) => state.set('error', error),

  [types.AUTH_USER_SET_SIGNED_OUT_EXPLICITLY]: (state, { signedOut }) =>
    state.set('signedOutExplicitly', signedOut),

  [types.AUTH_USER_RESET_DATA]: () => initialState
});



// WEBPACK FOOTER //
// ./src/reducers/auth-user.js